import { fireOperationalAnalytics } from '@atlassian/jira-analytics-web-react/src/utils/fire-operational-event.tsx';
import withInjectedProps from '@atlassian/jira-common-util-with-injected-props/src/index.tsx';
import LegacyApiBridge from './component.tsx';
import type { AnalyticsEvents } from './types.tsx';

const analyticsEvents: AnalyticsEvents = {
	onInsertItemFired: (analyticsEvent) =>
		fireOperationalAnalytics(analyticsEvent, {
			attributes: { method: 'insertItem' },
		}),
	onRemoveItemFired: (analyticsEvent) =>
		fireOperationalAnalytics(analyticsEvent, {
			attributes: { method: 'removeItem' },
		}),
	onSetRenderTargetFired: (analyticsEvent) =>
		fireOperationalAnalytics(analyticsEvent, {
			attributes: { method: 'render' },
		}),
	onOnBreadCrumbsUpdateFired: (analyticsEvent) =>
		fireOperationalAnalytics(analyticsEvent, {
			attributes: { method: 'onBreadCrumbsUpdate' },
		}),
};

export default withInjectedProps(LegacyApiBridge, analyticsEvents);
